import { Component, Input, OnInit } from '@angular/core';
import { FormControl, FormGroup, Validators } from '@angular/forms';
import { NgbActiveModal } from '@ng-bootstrap/ng-bootstrap';
import { OpProofcardService } from '../../services/op-proofcard.service';

@Component({
  selector: 'app-student-name-update',
  templateUrl: './student-name-update.component.html',
  styleUrls: ['./student-name-update.component.css']
})
export class StudentNameUpdateComponent implements OnInit {

  studentNameDialog: FormGroup;
  @Input() title: string;
  @Input() message: string;
  @Input() ProofcardData: any;
  @Input() btnOkText: string;
  @Input() btnCancelText: string;

  constructor(private activeModal: NgbActiveModal, private proofcardService: OpProofcardService,) { }

  buildStudentDialogForm(){
    this.studentNameDialog = new FormGroup({
      proofcardId: new FormControl(""),
      name: new FormControl("", Validators.required),
    });
  }

  ngOnInit() {
    this.buildStudentDialogForm();
  }
  onSubmit(formValues) {
    this.proofcardService.updateStudentName(this.ProofcardData.id, formValues.name).subscribe((res: any) => {
      if (res.statusCode == 200) {
        this.activeModal.close(true)
      }
    });
  }
  public dismiss() {
    this.activeModal.dismiss();
  }

}
